import EfNavPage from '@elem/ui/ef-nav-page';
import { useRouter } from 'next/router';
import { Fragment } from 'react';
import './index.scss';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { list = [], bgColor, textColor, textActiveColor, textActiveBgColor } = data;
    const items: { title: any; href: string }[] = [];
    const { asPath = '' } = useRouter();
    let initIndex2 = isEditStatus ? initIndex : 0;
    list.forEach((item: any, indexA: number) => {
        if (item.title) {
            if (item.hrefType === 'other') {
                //其它外链
                if (item.hrefOut) {
                    items.push({
                        title: item.title,
                        href: item.hrefOut,
                    });
                }
            } else if (item.href) {
                //本页面ID
                items.push({
                    title: item.title,
                    href: `#${item.href}`,
                });
            }
        }
    });
    items.forEach((item: any, indexA: number) => {
        if (asPath.includes(item.href)) {
            initIndex2 = indexA;
        }
    });

    return (
        <Fragment>
            <EfNavPage
                items={items}
                bgColor={bgColor}
                textColor={textColor}
                textActiveColor={textActiveColor}
                textActiveBgColor={textActiveBgColor}
                className="editor-temp temp-member-page-nav"
                initIndex={initIndex2}
                isEditStatus={isEditStatus}
            />
        </Fragment>
    );
}
